import { NgClass } from '@angular/common';
import { Component, effect, inject, OnDestroy, OnInit, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { SvgIconComponent, SvgIconRegistryService } from 'angular-svg-icon';
import { Subject, takeUntil } from 'rxjs';
import { WorkflowSection } from '../../models/workflow/workflow-section.model';
import { ProgressFlowService } from './progress-flow.service';

@Component({
  selector: 'seth-progress-flow',
  standalone: true,
  imports: [
    MatStepperModule,
    FormsModule,
    SvgIconComponent,
    NgClass,
  ],
  templateUrl: './progress-flow.component.html',
  styleUrl: './progress-flow.component.scss',
})
export class ProgressFlowComponent implements OnInit, OnDestroy {
  private _progressFlowService: ProgressFlowService = inject(ProgressFlowService);

  showProgressStepper$: WritableSignal<boolean> = this._progressFlowService.showProgressStepper();
  stepper$: WritableSignal<number> = this._progressFlowService.getMobileIndex();
  workflowSections$: WritableSignal<WorkflowSection[]> = this._progressFlowService.getWorkflowSections();
  svgRegistry: SvgIconRegistryService = inject(SvgIconRegistryService);
  destroy$: Subject<boolean> = new Subject<boolean>();
  selectedIndex = 0;

  constructor() {
    effect(() => {
      this.selectedIndex = this.stepper$();
    });
  }

  ngOnInit(): void {
    this.svgRegistry.loadSvg("../../assets/img/completed.svg", "completed")?.pipe(takeUntil(this.destroy$)).subscribe();
    this.svgRegistry.loadSvg("../../assets/img/in-progress.svg", "in-progress")?.pipe(takeUntil(this.destroy$)).subscribe();
    this.svgRegistry.loadSvg("../../assets/img/not-started.svg", "not-started")?.pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
